var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1613_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2987 31.5305C34.2053 31.5305 38.1828 27.5529 38.1828 22.6464C38.1828 17.7398 34.2053 13.7622 29.2987 13.7622C24.3921 13.7622 20.4146 17.7398 20.4146 22.6464C20.4146 27.5529 24.3921 31.5305 29.2987 31.5305Z",
    fill: "#CD566C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 28.4939C18.7537 28.4939 13.3585 32.0983 10.7652 37.3477C10.7167 37.4968 10.6343 37.6195 10.5416 37.7123C10.3464 37.9074 10.126 37.9528 10.0714 37.9637C10.0265 37.9727 9.98837 37.9769 9.96092 37.979C9.94657 37.9801 9.93349 37.9807 9.92192 37.9811L9.90529 37.9816L9.89759 37.9817L9.89388 37.9817L9.89116 37.9817C9.89071 37.9817 9.89027 37.9817 9.89025 37.0671L9.89027 37.9817C9.38513 37.9817 8.97562 37.5722 8.97561 37.0671C8.97561 37.0656 8.97562 37.0642 8.97562 37.0627C8.9744 36.9248 9.00433 36.7856 9.06722 36.6559C11.9336 30.7432 17.9834 26.6646 25 26.6646C32.0166 26.6646 38.0664 30.7432 40.9328 36.6559C40.9931 36.7802 41.0244 36.9166 41.0244 37.0549V37.0668C41.0244 37.5719 40.6149 37.9817 40.1098 37.9817C39.7127 37.9817 39.3747 37.7287 39.2483 37.3751C36.6603 32.1109 31.2571 28.4939 25 28.4939ZM9.2435 37.7016C9.23538 37.6935 9.22075 37.6788 9.20239 37.6577C9.21555 37.6727 9.22925 37.6873 9.2435 37.7016Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0001 13.0183C21.2318 13.0183 18.1769 16.0731 18.1769 19.8415C18.1769 23.6098 21.2318 26.6646 25.0001 26.6646C28.7684 26.6646 31.8233 23.6098 31.8233 19.8415C31.8233 16.0731 28.7684 13.0183 25.0001 13.0183ZM16.3477 19.8415C16.3477 15.0629 20.2215 11.189 25.0001 11.189C29.7787 11.189 33.6525 15.0629 33.6525 19.8415C33.6525 24.6201 29.7787 28.4939 25.0001 28.4939C20.2215 28.4939 16.3477 24.6201 16.3477 19.8415Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4939 9.90383C15.082 6.69242 19.8154 4.7439 25.0002 4.7439C36.1883 4.7439 45.2563 13.8119 45.2563 25C45.2563 36.1881 36.1883 45.2561 25.0002 45.2561C13.8122 45.2561 4.74414 36.1881 4.74414 25C4.74414 21.0293 5.88737 17.3243 7.86073 14.195C8.13018 13.7678 8.69498 13.6398 9.12226 13.9093C9.54953 14.1787 9.67748 14.7435 9.40803 15.1708C7.6131 18.0171 6.57341 21.3853 6.57341 25C6.57341 35.1778 14.8224 43.4268 25.0002 43.4268C35.178 43.4268 43.4271 35.1778 43.4271 25C43.4271 14.8222 35.178 6.57316 25.0002 6.57316C20.2826 6.57316 15.9794 8.34415 12.7139 11.2669C12.3375 11.6038 11.7593 11.5717 11.4224 11.1953C11.0855 10.8189 11.1175 10.2407 11.4939 9.90383Z",
    fill: "#060606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1613_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon-avatar.fb09b16999cb2a3f14d819b7691c03da.svg";
export { ForwardRef as ReactComponent };